module.exports = __webpack_public_path__ + "img/5.6a0fc0d1.jpg";